import {createFileRoute} from '@tanstack/react-router';
import {SavedAccountPage} from 'features/saved-accounts/pages/SavedAccountPage';

export const Route = createFileRoute('/_protected/home/service/saved-account')({
  component: SavedAccountPage,
  staticData: {crumbKey: 'connect-account.title'},
});
